
import { Button, Icon } from "@blueprintjs/core"
import { Fragment } from "react"
import Shortcode from "src/libs/useful/shortcode"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILandingContent } from "src/modules/pe-landing-module/data/interfaces"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import { ISectionProps } from "../section/Section"
import updateSection from "./utils/updateSection"
import { showToast } from "src/libs/useful"

/* Protopia Ecosystem component */ 
const SectionHidden = (props: ISectionProps): JSX.Element => {  
    const onShow = () => { 
        const historyStep: IHistoryStep = { 
            type: HISTORY_TYPE.SECTION, 
            title: __("Show section"), 
            prevData: props.section,
            data: { ...props.section, isHidden: false },
        }
        if( updateSection(  historyStep.data, historyStep ) ) {
            showToast({ message: "Section showed" })
        } 
    }
    return <Button fill className=" btn-stretch landing-edit-section-hidden" onClick={onShow}>
        <div className="container">
            <div className=" row py-3 ">
                <div className="col-md-8 offset-md-4 d-flex">
                    <Icon icon="eye-off" size={22} className="mx-2"/>
                    <Shortcode className="px-3" content={ props.section.title?.text || __( "Section" ) + " <span class='opacity_75 small'>#" + props.section.id + "</span>" } />
                    {
                        props.section.data.map((content: ILandingContent ) => {
                            const schema: any = components()[ content.type ] || {}
                            return <Fragment key={ content.id }>
                                <img src={ schema.icon } alt="" height={16} /> 
                            </Fragment>
                        })
                    }
                </div>
            </div>
        </div>
        
    </Button>
}
export default SectionHidden